// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YOtE","label":"styles_label__2gmR6"};